<input class="form-control form-control-dark w-100" id="search" type="text" placeholder="Suche..." aria-label="Search" #search autofocus>
